import {CustomTag, CustomTagsGateway} from "@livechat/tags";
import {UseCase} from "@livechat/shared";
import {Observable} from "rxjs";

export class EditTagUseCase implements UseCase<CustomTag, Observable<CustomTag>> {
  constructor(private tagsGateway: CustomTagsGateway) {
  }

  execute(params: CustomTag): Observable<CustomTag> {
    return this.tagsGateway.update(params)
  }
}
